import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { ES_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { EstablishRequestCode } from '@doda/api-client/aspida/@types';

/**
 * 設立年数のAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @returns 設立年数のAPIリクエスト
 */
export const createEstablishApiRequest = (queryParams: AppQueryParams) => {
  let establishName = '';
  let es = '';

  if (queryParams.es) [es] = queryParams.es;
  const findEs = ES_SEARCH_ITEMS.find((option) => option.id === es);
  if (findEs && findEs.seoText) {
    establishName = findEs.seoText;
  } else {
    // マスタに存在する値かの判定
    throw new Error('パラメータの不正(es)');
  }
  const requestEstablishId = queryParams.es as
    | EstablishRequestCode[]
    | undefined;

  return { establishName, requestEstablishId };
};
